import * as actionTypes from "./actionTypes";

const initialState = {
  allProducts: [],
  filterList: [],
  currentProducts: {},
  editedCurrentProducts: {},
  totalIndex: null,
  filter: null,
  getProductsFailed : false,
  totalRecords:0
};

const productStorereducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.saveBotsActionType:
        return {
          ...state,
          allProducts: [...action.payload.data],
          totalIndex: action.payload.data.lenght,
          filter: action.payload.filter,
	  totalRecords: action?.payload?.total,
        };
    case actionTypes.saveCurrentBotActionType:
      return {
        ...state,
        currentProducts: action.payload
      };
    case actionTypes.saveFilterListProdnType:
   
     //console.log("in reducer", action.payload)
      return {
        ...state,
        filterList: action.payload.data
      };

    case actionTypes.editCurrentBotActionType:
      return {
        ...state,
        editedCurrentProducts: { ...state.editedCurrentProducts, [action.payload.botID]: {...action.payload} },
      };

    case actionTypes.getBotsFailed:
      return {
        ...state, 
        getProductsFailed : !state.currentProducts

      }  
    default:
      return state;
  }
};

export default productStorereducer;

